
<div class="schedule-date-filter-row">
  <button type="button" class="btn btn-primary square-button" (click)="previousDate()">
    <i class="fas fa-arrow-left"></i>
  </button>
  <p-calendar class="form-control date-input"
      dateFormat="dd/mm/yy"
      [(ngModel)]="filterDate"
      panelStyleClass="popupAboveDate-schedule-time"
      (onSelect)="onFilterStartDateChange()">
  </p-calendar>
  <button type="button" class="btn btn-primary square-button" (click)="nextDate()">
    <i class="fas fa-arrow-right"></i>
  </button>
</div>

<div class="schedule-date-radio-row">
  <label class="radio-label">
    <input type="radio" name="days_to_show" [(ngModel)]="daysToShow" [value]="1" (ngModelChange)="onDaysToShowChange()">
    1 day
  </label>
  <label class="radio-label">
    <input type="radio" name="days_to_show" [(ngModel)]="daysToShow" [value]="2" (ngModelChange)="onDaysToShowChange()">
    2 days
  </label>
  <label class="radio-label">
    <input type="radio" name="days_to_show" [(ngModel)]="daysToShow" [value]="7" (ngModelChange)="onDaysToShowChange()">
    1 Week
  </label>
</div>
